<script>

import 'bootstrap-vue/dist/bootstrap-vue.css';

export default {
	components: {},
	props: ['user'],
	data() {
		return {

			google_code: null,

			password: null,
			password_confirmation: null,

			errors: {},

		}
	},
	mounted() {

		if (!this.user.password_changed) {

			$('#setPassword').modal('toggle');

			this.$refs.password.focus();
		}

	},
	methods: {
		changePassword() {
			$('#setPassword').modal('toggle');
		},
		onCancel() {
			window.location.href='/user/profile'
		},
		async activate2Fa() {

			await axios.post('/user/activate-2fa', {'google_code': this.google_code}).then(response => {

				window.location.href='/user/profile'

			}).catch(error => {

				if (error.response.status === 422 && error.response.data.errors) {
					this.errors = error.response.data.errors || {};
				}

				if (error.response.status === 400 && error.response.data.errors) {
					this.errors = error.response.data.errors || {};
				}

			});

		},
		async onConfirm() {

			this.errors = {};

			await axios.patch('/user/set-password', {'password': this.password, 'password_confirmation': this.password_confirmation}).then(response => {

				$('#setPassword').modal('toggle');

				flash('Password was successfully changed!', 'success');

			}).catch(error => {

				console.log("1");
				console.log(error);

				if (error.response.status === 422 && error.response.data.errors) {
					this.errors = error.response.data.errors || {};
				}

			});
		},
		allowSubmit()
		{
			if (this.password === null) {
				return false;
			}

			if (this.password_confirmation === null) {
				return false;
			}

			return this.password === this.password_confirmation;


		}
	}
}
</script>
